import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Paragraphs from 'components/common/Paragraphs';

class Intro extends Component {
	render() {
		const className = (this.props.open)? "is-open" : "is-closed";
		return (
			<div id="Intro" className={className}>
				<section className="Columns">
					<main>
						<Paragraphs text={this.props.description} />
						<p><Link to="/about">More about us →</Link></p>
					</main>
					<aside>
						<Paragraphs text={this.props.contact} />
					</aside>
				</section>
			</div>
		)
	}
}
Intro.propTypes = {
	description: PropTypes.string,
	contact: PropTypes.string,
	open: PropTypes.bool
}
Intro.defaultProps = {
	description: "",
	contact: "",
	open: false,
}
const mapStateToProps = (state) => {
	return {
		description: state.config.site_description,
		contact: state.config.site_contact,
		open: state.status.show_description,
	}
}
export default connect(mapStateToProps)(Intro);


// WEBPACK FOOTER //
// ./src/components/Header/Intro.jsx